// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/colors.module.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/styles.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AppContentView-module_header_box_UACMm {
  width: 100%;
  flex: 0 0 auto;
  position: sticky;
  top: 0;
  left: 0;
}

.AppContentView-module_bread_crumb_box_gOEjt {
  font-family: Montserrat, sans-serif;
  padding: 4px 10px 2px;
  background-color: var(--uu-breadcrumb-bg);
  border-bottom: 1px solid var(--uu-utah-red);
}

.AppContentView-module_bread_crumb_ISM1s a,
.AppContentView-module_bread_crumb_ISM1s span {
  font-size: 13px;
  font-weight: 500;
  color: var(--uu-utah-red);
  transition: all 0.25s ease;
}

.AppContentView-module_bread_crumb_ISM1s span svg {
  height: 14px;
  width: 14px;
}

.AppContentView-module_bread_crumb_ISM1s > li a:hover {
  color: var(--primary-hover-color);
  transform: translateY(-1px);
}

.AppContentView-module_bread_crumb_ISM1s > li:last-of-type {
  pointer-events: none;
  font-weight: 600;
}

.AppContentView-module_bread_crumb_ISM1s > li:last-of-type a,
.AppContentView-module_bread_crumb_ISM1s > li:last-of-type span {
  color: var(--main-nav-bg-color);
}

.AppContentView-module_dummy_box_AfZag {
  width: 100%;
}

.AppContentView-module_scrollable_content_sPo2H {
  flex: 1 1 auto;
  margin: 12px 20px;
  padding: 6px;
  overflow: auto;
}

.AppContentView-module_content_no_padding_dZg7a {
  margin: 0;
  padding: 0;
}

.AppContentView-module_footer_content_h9Ebo {
  width: 100%;
  position: sticky;
  bottom: 0;
  background-color: var(--uu-footer-bottom-bg);
}
`, "",{"version":3,"sources":["webpack://./src/client/components/Generic/AppContentView/AppContentView.module.css"],"names":[],"mappings":"AAAA;EAEE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EAEE,WAAW;AACb;;AAEA;EAEE,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,cAAc;AAChB;;AAEA;EAEE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,4CAA4C;AAC9C","sourcesContent":[".header_box {\n  composes: primary_background from 'Styles/colors.module.css';\n  width: 100%;\n  flex: 0 0 auto;\n  position: sticky;\n  top: 0;\n  left: 0;\n}\n\n.bread_crumb_box {\n  font-family: Montserrat, sans-serif;\n  padding: 4px 10px 2px;\n  background-color: var(--uu-breadcrumb-bg);\n  border-bottom: 1px solid var(--uu-utah-red);\n}\n\n.bread_crumb a,\n.bread_crumb span {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--uu-utah-red);\n  transition: all 0.25s ease;\n}\n\n.bread_crumb span svg {\n  height: 14px;\n  width: 14px;\n}\n\n.bread_crumb > li a:hover {\n  color: var(--primary-hover-color);\n  transform: translateY(-1px);\n}\n\n.bread_crumb > li:last-of-type {\n  pointer-events: none;\n  font-weight: 600;\n}\n\n.bread_crumb > li:last-of-type a,\n.bread_crumb > li:last-of-type span {\n  color: var(--main-nav-bg-color);\n}\n\n.dummy_box {\n  composes: primary_background from 'Styles/colors.module.css';\n  width: 100%;\n}\n\n.scrollable_content {\n  composes: scrollbar_container from 'Styles/styles.module.css';\n  flex: 1 1 auto;\n  margin: 12px 20px;\n  padding: 6px;\n  overflow: auto;\n}\n\n.content_no_padding {\n  composes: scrollable_content;\n  margin: 0;\n  padding: 0;\n}\n\n.footer_content {\n  width: 100%;\n  position: sticky;\n  bottom: 0;\n  background-color: var(--uu-footer-bottom-bg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header_box": `AppContentView-module_header_box_UACMm ${___CSS_LOADER_ICSS_IMPORT_0___.locals["primary_background"]}`,
	"bread_crumb_box": `AppContentView-module_bread_crumb_box_gOEjt`,
	"bread_crumb": `AppContentView-module_bread_crumb_ISM1s`,
	"dummy_box": `AppContentView-module_dummy_box_AfZag ${___CSS_LOADER_ICSS_IMPORT_0___.locals["primary_background"]}`,
	"scrollable_content": `AppContentView-module_scrollable_content_sPo2H ${___CSS_LOADER_ICSS_IMPORT_1___.locals["scrollbar_container"]}`,
	"content_no_padding": `AppContentView-module_content_no_padding_dZg7a AppContentView-module_scrollable_content_sPo2H ${___CSS_LOADER_ICSS_IMPORT_1___.locals["scrollbar_container"]}`,
	"footer_content": `AppContentView-module_footer_content_h9Ebo`
};
export default ___CSS_LOADER_EXPORT___;
